import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { Typography } from "@mui/material";

const FooterDown = () => {
  return (
    <Grid container justifyContent="center" className={styles.footerDownContainer}>
      <Grid size={{ xs: 12, sm: 11, md: 11, lg: 8, xl: 7, xxl:5 }} >
        <Grid container justifyContent='center'>
          <Grid >
            <Typography className={styles.footerDownSubContainer}>
            Copyright © 2025 JP Capital LLC. All Rights Reserved.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FooterDown;
